// components/filters/TotalOOFilter.js
import React from "react";
import FilterBase from "../FilterBase";
import Input from "../../ui/Input";
import Space from "../../ui/Space";
import { FILTER } from "../../utils/Struct";
import Button from "../../ui/Button";
import DateField from "../../ui/DateField";
import { bm_date } from "../../utils/Utils";
import { ENUMS } from "../../utils/Enums";
import { drawPicker } from "../../popovers/Picker";
import { ROUTES } from "../../utils/Routes";

export default function GenericConditional(props) {

    const { controller = "", onSave = () => { }, onClose = () => { }, filter = {}, allow_in = false, date = false, edit = false, inputParams = { number: true, maxLength: 3, width: 35 } } = props;

    const route = ROUTES.REPORTS.FILTER_EDIT;
    const { value = 1,  type = "" } = filter;

    let text = filter.text; 
    let _data = ENUMS.REPORT_FILTERS.find(item => item.value === type) || false; 

    if(_data){
        text = _data.text; 
    }

    const fields = [
        { key: "comparison", value: (edit) ? filter.comparison : "=", help: "= equal, < less, > greater  (PgUp to select)" },
        { key: "value_1", value: (edit) ? filter.value_1 : (inputParams.number) ? "" : "", help: "Enter the data to complete this filter." },
        { include: true, label: "save", key: "save", value: "", help: "Press Enter to save" },
    ];

    const save = (tabs) => {
        const comparison = tabs.find(f => f.key === "comparison").value;
        let value_1 = tabs.find(f => f.key === "value_1").value;

        if (date) {
            value_1 = bm_date(value_1, "YYYY-MM-DD");
        }

        const _f = {
            ...FILTER,
            type: value,
            comparison: comparison,
            value_1: value_1.toString()
        }
        onSave(_f, filter);
    }

    const chars = (allow_in) ? [">", "<", "=", "$"] : [">", "<", "="]

    const drawSelect = (_value, _ref, _update, _index, _proceed) => {

        drawPicker({
            controller : controller,
            value: _value, title: "Select", closeable: true, height: 300, ref: _ref, route: route, close: () => { _ref.focus(); }, callback: (e) => {
                if (e) {
                    _update(_index, e);
                    setTimeout(() => {
                        _proceed(e)
                    }, 10)
                }
            }, offset: [0, 10],
            options: chars.map(item => {
                return { value: item, label: item }
            })
        })

    }

    

    return (
        <FilterBase controller={controller} start_index={0} fields={fields} onClose={() => onClose()} onSave={(tabs) => {
            save(tabs)
        }}>
            {({ editProps, update, tabs, proceed, refs, index }) => (
                <div>
                    <Space>
                        <span>{text}</span>
                        <Input {...editProps("comparison")} chars={chars} onPageUp={(e) => drawSelect(e, refs?.current?.[index], update, index, proceed)} onFill={(e) => proceed(e)} maxLength={1} width={20} />
                        {(!date && <Input {...editProps("value_1")} {...inputParams} onFill={(e) => proceed(e)} />)}
                        {(date && <DateField {...editProps("value_1")} {...inputParams} onFill={(e) => proceed(e)} />)}
                        <Button onClick={() => save(tabs)} {...editProps("save")} >Save</Button>
                    </Space>
                </div>
            )}
        </FilterBase>
    );
}
